import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const Dot = ({ size = 'large', className, ...rest }: { className?: string; size?: 'large' | 'small' }) => {
  return (
    <div
      css={[
        dotStyles,
        css`
          width: ${size === 'large' ? '12px' : '6px'};
          height: ${size === 'large' ? '12px' : '6px'};
        `,
      ]}
      className={className}
      {...rest}
    ></div>
  );
};

const dotStyles = css`
  background-color: ${theme.colors.neutral70};
  border-radius: 50%;
  position: relative;
`;
